<template>
  <v-row no-gutters class="fill-height">
    <v-col cols="12" class="fill-height">
      <v-card class="mb-2">
        <v-row no-gutters justify="center" align="center">
          <v-col cols="8">
            <v-row>
              <v-col cols="6">
                <VueCtkDateTimePicker
                  id="startDate"
                  format="YYYY-MM-DD HH:mm"
                  output-format="YYYY-MM-DD HH:mm"
                  formatted="YYYY-MM-DD HH:mm"
                  label="Start Date"
                  v-model="startDate"
                />
              </v-col>
              <v-col cols="6">
                <VueCtkDateTimePicker
                  id="endDate"
                  format="YYYY-MM-DD HH:mm"
                  output-format="YYYY-MM-DD HH:mm"
                  formatted="YYYY-MM-DD HH:mm"
                  label="End Date"
                  v-model="endDate"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="auto" shrink class="ml-2">
            <v-btn color="primary" @click="fetchHeaderTxes" small>Filter</v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-col cols="12" style="height: calc(100% - 66px); position:relative; overflow: auto;">
        <v-overlay v-model="fetchingData" absolute>fetching data...</v-overlay>
        <Grid
          ref="AssesmentHeaderGrid"
          :Headers="Headers"
          :rowData="rowData"
          :setSelectedMethod="setSelected"
          :extraOptions="gridOptions"
          :chartID="chartID"
          :GridStyle="`height: 100%`"
        />
      </v-col>
    </v-col>
  </v-row>
</template>

<script>
import Grid from "@/components/Reports/report-base.vue";

export default {
  components: {
    Grid
  },
  data() {
    let self = this;
    return {
      chartID: self.guid(),
      selectedAssesment: null,
      rowData: [],
      Headers: [],
      txRowData: [],
      txHeaders: [],
      fetchingData: false,
      startDate: null,
      gridOptions: {
        enableCharts: true,
        getRowStyle: function(params) {
          if (params.data == undefined) {
            return { background: "" };
          }

          if (params.data.Score >= params.data.RequiredScore) {
            return { background: "lightgreen" };
          } else {
            return { background: "#FF6262" };
          }
        },
        onFirstDataRendered: function(params) {
          var createRangeChartParams = {
            cellRange: {
              columns: ["ReferenceText", "RequiredScore", "Score"]
            },
            chartType: "groupedColumn",
            chartContainer: document.querySelector(`#${self.chartID}`),
            suppressChartRanges: true,
            aggFunc: "sum"
          };

          var chartRef = params.api.createRangeChart(createRangeChartParams);
        },
        processChartOptions: function(params) {
          var opts = params.options;

          opts.legend.position = "right";
          // opts.yAxis.label.formatter = yAxisLabelFormatter;
          opts.seriesDefaults.tooltip.enabled = true;
          opts.seriesDefaults.fill.colors = [
            "#c16068",
            "#a2bf8a",
            "#ebcc87",
            "#80a0c3",
            "#b58dae",
            "#85c0d1"
          ];
          opts.seriesDefaults.stroke.colors = [
            "#874349",
            "#718661",
            "#a48f5f",
            "#5a7088",
            "#7f637a",
            "#5d8692"
          ];

          opts.seriesDefaults.tooltip.renderer = function(params) {
            var value = params.datum[params.yKey]
              .toString()
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
            return (
              '<div style="padding: 5px"><b>' +
              params.title +
              "</b>: " +
              value +
              "%</div>"
            );
          };

          return opts;
        }
      },
      endDate: this.FormatDateTime(new Date().setHours(23, 59, 59, 999))
    };
  },
  beforeMount() {
    let startMonth = this.subtractMonth(new Date().setHours(0, 0, 0, 0), 1);
    this.startDate = this.FormatDateTime(startMonth);
    this.Headers = [
      {
        headerName: "Staff Member",
        field: "StaffMember",
        resizable: true,
        filter: true,
        enableRowGroup: true,
        sortable: true,
        valueParser: this.valueParser,
        rowGroup: true,
        hide: true
      },
      {
        headerName: "Assessment Name",
        field: "AssessmentName",
        resizable: true,
        filter: true,
        enableRowGroup: true,
        sortable: true,
        valueParser: this.valueParser,
        rowGroup: true,
        hide: true
      },
      {
        headerName: "Open Time",
        field: "OpenTxTimeString",
        resizable: true,
        filter: true,
        enableRowGroup: true,
        sortable: true,
        valueParser: this.valueParser,
        rowGroup: true,
        hide: true
      },
      {
        headerName: "Reference Text",
        field: "ReferenceText",
        enableRowGroup: true,
        resizable: true,
        filter: true,
        sortable: true,
        valueParser: this.valueParser
      },
      {
        headerName: "Pass Rate",
        field: "RequiredScore",
        enableValue: true,
        resizable: true,
        filter: true,
        sortable: true,
        valueParser: this.valueParser
      },
      {
        headerName: "Rated Score",
        field: "Score",
        enableValue: true,
        resizable: true,
        filter: true,
        sortable: true,
        valueParser: this.valueParser
      }
    ];
  },
  mounted() {
    let self = this;
    self.fetchHeaderTxes();
  },
  methods: {
    setSelected(item) {
      let self = this;
      self.selectedAssesment = item;
    },
    fetchHeaderTxes() {
      let self = this;
      let url = `Tenant/Report/Transaction/Assessment/GetScores?startDate=${self.startDate}&endDate=${self.endDate}`;

      self.fetchingData = true;

      self
        .get(url)
        .then(r => {
          self.rowData = r.data;
          self.fetchingData = false;
        })
        .catch(err => {
          self.fetchingData = false;
        });
    }
  }
};
</script>